import React from "react";
import "./BridalGalleryOn.css";

function BridalGalleryOn(props) {
  const { children } = props;

  return (
    <div className="bridal-gallery-on">
      <div className="bridal-makeup-5 poppins-medium-white-10px">{children}</div>
    </div>
  );
}

export default BridalGalleryOn;
